import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import TeletelBrandingIndex from './Index.vue';

/**
 * Branding control, Teletel's own path.
 *
 * The Chatwoot disable_branding feature stays premium and untouched; this is a
 * separate route, component, endpoint and storage (account.settings), so the
 * nightly plan reconciliation cannot revert it. It also goes further than the
 * stock flag: it covers the survey page and the help-centre footer, and can
 * replace the footer instead of only hiding it.
 *
 * Administrators only. The server enforces the same rule, so hiding the route
 * is a convenience, never the control.
 */
export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/teletel-branding'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => ({ name: 'teletel_branding', params: to.params }),
        },
        {
          path: 'list',
          name: 'teletel_branding',
          meta: {
            permissions: ['administrator'],
          },
          component: TeletelBrandingIndex,
        },
      ],
    },
  ],
};
